import cfg from 'client/common/utils/client-config';

import type {Revision, SurveySlug} from 'client/common/types';

import {_doRequest} from './base';
import {Response, SuccessfulResponse} from './types';

export type Poll = Pick<Revision, 'groups' | 'widgets' | 'pageOrder' | 'questions'> & {
    lang: string;
    scope: string[];
    metrika: number[];
    redirects: any;
    respReuse: true;
    metrikaTitle: string;
    _ivid: string;
};

export const getPollStart = async ({
    slug,
    params
}: {
    slug: SurveySlug;
    params: Record<string, string>;
}): Promise<Response<SuccessfulResponse<Poll>>> => {
    const searchParams = new URLSearchParams(params);

    const requestParams = {
        method: 'POST',
        endpoint: cfg.surveyEndpoint,
        disableCSRF: true,
        retries: [3000],
        url: `/api/v0/survey/${slug}/start?${searchParams.toString()}`,
        data: {
            _seqnum: 1
        },
        passQuery: false
    };

    return _doRequest(requestParams);
};

export const sendPollFinish = async ({
    slug,
    questionId,
    options,
    params
}: {
    slug: SurveySlug;
    questionId: string;
    options: number[];
    params: Record<string, string>;
}): Promise<any> => {
    const searchParams = new URLSearchParams(params);

    const requestParams = {
        method: 'POST',
        endpoint: cfg.surveyEndpoint,
        disableCSRF: true,
        retries: [3000],
        url: `/api/v0/survey/${slug}/finish?${searchParams.toString()}`,
        data: {
            answers: [{options, text: '', questionId}],
            _seqnum: 2
        },
        passQuery: false
    };

    return _doRequest(requestParams);
};
